const getCmsParams = (path, routeKey) => {
  const pathSlugs = path.split('/').filter(Boolean);
  const routeKeySlugs = routeKey.split('/').filter(Boolean);

  return routeKeySlugs.reduce((params, slug, index) => {
    if (slug.startsWith(':')) {
      return {
        ...params,
        [slug.slice(1)]: pathSlugs[index],
      };
    }

    return params;
  }, {});
};

export default getCmsParams;
